import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TareaService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getTarea(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareas', { headers: this.header(this.token) });
  }

  getTareaById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTarea/' + id, { headers: this.header(this.token) });
  }

  postTarea(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaTarea', bodyString, { headers: this.header(this.token) });
  }

  putTarea(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaTarea', bodyString, { headers: this.header(this.token) });
  }

  deleteTarea(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTarea/' + id, { headers: this.header(this.token) });
  }
  
  getTareasByOperacionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareasOperacion/' + id, { headers: this.header(this.token) });
  }

  getListTareasByOperacionId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'tareasByOperacionId/' + id, { headers: this.header(this.token) });
  }

  getProgramacionTarea(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'programacionTareaById/' + id, { headers: this.header(this.token) });
  }

  postProgramacionTarea(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'programacionTarea', bodyString, { headers: this.header(this.token) });
  }

  putProgramacionTarea(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'programacionTarea', bodyString, { headers: this.header(this.token) });
  }


}
